var APP_ROUTES = [
    {
        path: '',
        loadChildren: './pages/pages.module#PagesModule',
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];
var AppRoutingModule = (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/app.routing.ts.pre-build-optimizer.js